import { useAppSelector } from '@store';
import useCompanyItem from '../hooks/use-company-item';
import { CompanyItemTypes } from '../types';
import CompanyItemContent from '../../../../components/individual/overview/company-item';

const CompanyItem = ({ value, list, removed }: CompanyItemTypes) => {
  const { activePermissions } = useAppSelector((state) => state.root);

  const {
    formValues,
    updateStatusInProgress,
    employeeName,
    approveInProgress,
    defaultFormValues,
    cofIsUpdate,
    onApprove,
    setFormValues,
    updateCofAction,
    setPopupIsVisible,
    setRejectReason,
    onUpdateCofStatus,
    popupIsVisible,
    rejectReason,
  } = useCompanyItem({
    value,
    list,
    removed,
  });

  return (
    <CompanyItemContent
      value={value}
      removed={removed}
      activePermissions={activePermissions}
      formValues={formValues}
      updateStatusInProgress={updateStatusInProgress}
      employeeName={employeeName}
      approveInProgress={approveInProgress}
      defaultFormValues={defaultFormValues}
      cofIsUpdate={cofIsUpdate}
      onApprove={onApprove}
      setFormValues={setFormValues}
      updateCofAction={updateCofAction}
      setPopupIsVisible={setPopupIsVisible}
      setRejectReason={setRejectReason}
      onUpdateCofStatus={onUpdateCofStatus}
      popupIsVisible={popupIsVisible}
      rejectReason={rejectReason}
    />
  );
};

export default CompanyItem;
